import isEmpty from "is-empty";

export default class MessageClass {

    // properties
    createdAt = null;
    type = -1;
    text = "";
    userId = "";
    documentId = "";
    read = false;
    userIds = null;
    attachment = null;

    constructor() { }

    // setters
    setCreatedAt(createdAt) {
        this.createdAt = createdAt;
    }

    setType(type) {
        this.type = type;
    }

    setUserIds(userIds) {
        this.userIds = userIds;
    }

    setText(text) {
        this.text = text;
    }

    setUserId(userId) {
        this.userId = userId;
    }

    setDocumentId(documentId) {
        this.documentId = documentId;
    }

    setRead(isRead) {
        this.read = isRead;
    }

    setAttachment(attachment) {
        this.attachment = attachment;
    }

    toObject() {
        const obj = {};
        obj.userIds = this.userIds;
        obj.createdAt = this.createdAt;
        obj.text = this.text;
        obj.type = this.type;
        obj.userId = this.userId
        obj.read = this.read;

        if (!isEmpty(this.attachment)) {
            obj.attachment = this.attachment;
        }

        return obj;
    }
}